import { render, staticRenderFns } from "./profile-enrollments.vue?vue&type=template&id=6c1a9fbe&scoped=true&"
import script from "./profile-enrollments.ts?vue&type=script&lang=ts&"
export * from "./profile-enrollments.ts?vue&type=script&lang=ts&"
import style0 from "./profile-enrollments.scss?vue&type=style&index=0&id=6c1a9fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a9fbe",
  null
  
)

export default component.exports